import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { FaSearch } from 'react-icons/fa';
import 'bootstrap/dist/css/bootstrap.min.css';
import './priceLists.css';

const PriceListsForm = () => {
  const [formData, setFormData] = useState({
    pricelistType: 'procedures',
    includeInactive: false,
    procedure: [],
    attribute: '0',
    groups: [],
    format: ''
  });

  const handleChange = (e) => {
    const { name, value, type, checked, options } = e.target;

    if (type === 'checkbox') {
      setFormData(prevState => ({
        ...prevState,
        [name]: checked
      }));
    } else if (type === 'select-multiple') {
      const selectedOptions = Array.from(options)
        .filter(option => option.selected)
        .map(option => option.value);

      setFormData(prevState => ({
        ...prevState,
        [name]: selectedOptions
      }));
    } else {
      setFormData(prevState => ({
        ...prevState,
        [name]: value
      }));
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
  };

  return (
    <div className="pl-wrap">
      {/* Top Heading */}
      <div className="pl-desc">Price lists by procedure.</div>

      <div className="pl-box">
        {/* Section Heading */}
        <h2 className="pl-title">Parameters</h2>

        {/* Main Box Container */}
        <form onSubmit={handleSubmit} className="pl-panel">
          {/* Price List Type */}
          <div className="pl-row">
            <label className="pl-label" htmlFor="pricelistType">Price List Type</label>
            <div className="pl-field">
              <select
                id="pricelistType"
                name="pricelistType"
                value={formData.pricelistType}
                onChange={handleChange}
                className="pl-select"
              >
                <option value="procedures">Procedures</option>
                <option value="attributes">Attributes</option>
              </select>
            </div>
          </div>

          {/* Procedures Selection & Inactive Checkbox */}
          <div className="pl-row pl-row-top">
            <label className="pl-label" htmlFor="procedure">Procedures</label>
            <div className="pl-field pl-col">
              <label className="pl-check" htmlFor="includeInactive">
                <input
                  type="checkbox"
                  id="includeInactive"
                  name="includeInactive"
                  checked={formData.includeInactive}
                  onChange={handleChange}
                />
                Inactive Selectable?
              </label>

              <select
                id="procedure"
                name="procedure"
                value={formData.procedure}
                onChange={handleChange}
                multiple
                size="10"
                className="pl-multi pl-multi-lg"
              >
                <option value="404">3D PRINTED MODELS</option>
                <option value="435">3D PRINTED MODEL (HORSE SHOE SHA...</option>
                <option value="60">60% PRECIOUS GOLD CROWN</option>
                <option value="814d">8-14 ALIGNERS (DUAL ARCH)</option>
                <option value="814s">8-14 ALIGNERS (SINGLE ARCH)</option>
                <option value="adin2">ADIN - guided surgery sleeves 2mm</option>
                <option value="adin5">ADIN - guided surgery sleeves 5.5mm</option>
                <option value="alveo">ALVEOPLASTY CLEAR GUIDE</option>
                <option value="anchor">Anchor pin - Surgical Guide</option>
                <option value="anchortwist">Anchor Twist Drill - Surgical guide</option>
              </select>
            </div>
          </div>

          {/* Attribute Selection */}
          {formData.pricelistType === 'attributes' && (
            <div className="pl-row">
              <label className="pl-label" htmlFor="attribute">Attribute</label>
              <div className="pl-field">
                <select
                  id="attribute"
                  name="attribute"
                  value={formData.attribute}
                  onChange={handleChange}
                  className="pl-select"
                >
                  <option value="0">All</option>
                  <option value="1">Sports Guard Color</option>
                </select>
              </div>
            </div>
          )}

          {/* Pricelist Groups */}
          <div className="pl-row pl-row-top">
            <label className="pl-label" htmlFor="groups">Pricelist Groups</label>
            <div className="pl-field">
              <select
                id="groups"
                name="groups"
                value={formData.groups}
                onChange={handleChange}
                multiple
                className="pl-multi"
              >
                <option value="">No filter</option>
                <option value="1">1</option>
                <option value="bexley/batt">bexley/batt</option>
                <option value="default">default</option>
              </select>
            </div>
          </div>

          {/* Format Selection */}
          <div className="pl-row">
            <label className="pl-label" htmlFor="format">
              Format <span className="pl-req">*</span>
            </label>
            <div className="pl-field">
              <select
                id="format"
                name="format"
                value={formData.format}
                onChange={handleChange}
                required
                className="pl-select"
              >
                <option value="">On Screen</option>
                <option value="csv">CSV (Excel)</option>
              </select>
            </div>
          </div>

          {/* Submit Button */}
          <div className="pl-row pl-row-run">
            <span className="pl-label" />
            <Link to="/AddRevenuePrice" className="pl-link">
              <button type="submit" className="pl-run">
                <FaSearch /> Run
              </button>
            </Link>
          </div>
        </form>
      </div>
    </div>
  );
};

export default PriceListsForm;